import _Search from "@mui/icons-material/Search";
var _templateObject;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import NavBarItem from 'app/components/navBar/NavBarItem';
import styled from 'styled-components';
import { COLORS } from '@fupa/fupa-uikit';
const StyledSearch = styled(_Search).withConfig({
  componentId: "sc-1lzcihh-0"
})(["&&&{color:", ";font-size:20;", "}"], props => props.selected ? COLORS.fupaSecondary : COLORS.darkerGrey, props => props.theme.desktopLayout(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    fill: ", ";\n    padding-bottom: 0.75rem;\n    "])), props.selected ? COLORS.fupaSecondary : COLORS.lighterGrey));
export default function NavBarItemSearch(_ref) {
  let {
    isSelected,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(NavBarItem, _extends({
    isSelected: isSelected,
    follow: true,
    label: "Suche"
  }, props, {
    "data-sentry-element": "NavBarItem",
    "data-sentry-component": "NavBarItemSearch",
    "data-sentry-source-file": "NavBarItemSearch.tsx"
  }), /*#__PURE__*/React.createElement(StyledSearch, {
    selected: isSelected,
    "data-sentry-element": "StyledSearch",
    "data-sentry-source-file": "NavBarItemSearch.tsx"
  }));
}